import { createApiClient } from '../../shared/http/createApiClient.js';

const client = createApiClient({ auth: true });
const req = (method, path, body) => client.request(path, { method, body });

export const clientApi = {
  // Returns { clients: [{ id, name, is_active, modules: {id: bool} }], modules: [{id, label}] }.
  // The module list comes from the server rather than the frontend's registry mirror so the
  // checkbox row is generated by the same process that validates the registry.
  listClients:  ()          => req('GET',   '/client-management/clients'),
  createClient: (body)      => req('POST',  '/client-management/clients', body),
  updateClient: (id, body)  => req('PATCH', `/client-management/clients/${id}`, body),
  setModules:   (id, modules) => req('PUT', `/client-management/clients/${id}/modules`, { modules }),

  // What this client would leave behind in one module, asked before unchecking it. Returns
  // { checked, total, capped, items: [{ label, count, capped }] } — `checked: false` means the
  // module has nothing this can count, NOT that the client has no records there.
  dependents: (id, moduleId) =>
    req('GET', `/client-management/clients/${id}/dependents?module=${encodeURIComponent(moduleId)}`),
};
